import React from 'react';
import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PaymentRailsChips = ({ account }) => {
  const { t } = useTranslation();

  if (!account) return null;

  const rails = [];

  if (account.standard) {
    rails.push(
      <Chip
        key='standard'
        label={t('moov.paymentRails.standard')}
        size='small'
        color='success'
        variant='filled'
      />,
    );
  }

  if (account.same_day) {
    rails.push(
      <Chip
        key='same_day'
        label={t('moov.paymentRails.sameDay')}
        size='small'
        color='success'
        variant='filled'
      />,
    );
  }

  if (account.rtp) {
    rails.push(
      <Chip
        key='rtp'
        label={t('moov.paymentRails.rtp')}
        size='small'
        color='success'
        variant='filled'
      />,
    );
  }

  if (account.push_to_debit) {
    rails.push(
      <Chip
        key='push_to_debit'
        label={t('moov.paymentRails.pushToDebit')}
        size='small'
        color='success'
        variant='filled'
      />,
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
      {rails.length > 0 ? rails : <span>-</span>}
    </Box>
  );
};

export default PaymentRailsChips;
